import { IMessage, IVardata, MessageType } from '../mgs.types';

export function hasError(vardata: IVardata): boolean {
  return !!getErrorMessage(vardata);
}

export function getErrorMessage(vardata: IVardata): IMessage | undefined {
  return getMessage(vardata, 'error');
}

export function getErrorMessages(vardata: IVardata): IMessage[] | undefined {
  return getMessages(vardata, 'error');
}

export function getInfoMessage(vardata: IVardata): IMessage | undefined {
  return getMessage(vardata, 'info');
}

export function getMessage(vardata: IVardata, type: MessageType): IMessage | undefined {
  return vardata?.messages?.find((message) => type === message.type);
}

export function getMessages(vardata: IVardata, type: MessageType): IMessage[] {
  return vardata?.messages?.filter((message) => message.type === type) ?? [];
}
